import { User } from '@shared/api/user/user.interface';

/**
 * 로그인 기기 잠금. 백엔드 스펙: smartbugo-api/docs/login-device-lock.md
 *
 * 잠그는 단위는 기기(x-login-device-id)지만, 몇 번까지 봐줄지는 시도한 대상 계정이 정한다.
 */

export enum LoginLockTier {
  /** 고객·게스트 — 잠그지 않는다 */
  None = 'None',
  /** 작업자급 — 10회 */
  Relaxed = 'Relaxed',
  /** 관리자급 — 5회 */
  Strict = 'Strict',
}

export const LOGIN_LOCK_TIER_LABEL: Record<LoginLockTier, string> = {
  [LoginLockTier.None]: '고객',
  [LoginLockTier.Relaxed]: '작업자급',
  [LoginLockTier.Strict]: '관리자급',
};

export interface LoginDeviceLock {
  _id: string;
  deviceId: string;
  failCount: number;
  windowStartAt: Date | string;
  /** 이 창에서 시도한 아이디 (최근 20개). 전화 해제 시 검색 키 */
  usernames: string[];
  tier?: LoginLockTier;
  lastIp?: string;
  lastUserAgent?: string;
  lastFailedAt?: Date | string;
  lockedAt?: Date | string;
  lockedUntil?: Date | string;
  releasedAt?: Date | string;
  releasedBy?: User | string;
  releaseNote?: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  /** 서버가 계산해 주는 "지금 잠겨 있는가" — lockedUntil 만 보고 판단하지 말 것 */
  active: boolean;
}
